<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <!-- 选择客户 -->
          <div class="tool">
            <h4>选择客户</h4>
            <div class="search">
              <el-select
                v-model="customerValue"
                placeholder="请选择客户"
                @change="customerChange"
                :loading="customerLoading"
                filterable>
                <el-option
                  v-for="item in customerData"
                  :key="item.client_id"
                  :label="item.number + ' ' + item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 页面标题 -->
          <div class="part">
            <div class="page_header">
              <i class="el-icon-film header_icon"></i>
              <h3>拼接长视频</h3>
            </div>
          </div>

          <!-- 素材编辑区 -->
          <div class="part">
            <div class="editor_header">
              <h5>素材编辑区（{{ selectedItems.length }} 个素材）</h5>
              <div class="editor_actions">
                <el-button type="success" size="small" plain @click="openLibrary">
                  <i class="el-icon-plus"></i> 从生成库选择
                </el-button>
                <el-button type="success" size="small" plain @click="uploadOpen = true">
                  <i class="el-icon-plus"></i> 上传新素材
                </el-button>
              </div>
            </div>

            <!-- 空状态 -->
            <div v-if="selectedItems.length === 0" class="empty_editor">
              <i class="el-icon-film empty_icon"></i>
              <p>还没有添加素材</p>
              <p class="empty_hint">请点击右上角按钮添加素材</p>
            </div>

            <!-- 素材列表 -->
            <div v-else class="material_list" ref="materialList">
              <div
                v-for="(item, index) in selectedItems"
                :key="item.id"
                :class="['material_item', { 'dragging': dragIndex === index }]"
                :data-index="index"
                draggable="true"
                @dragstart="handleDragStart($event, index)"
                @dragover.prevent="handleDragOver($event, index)"
                @drop="handleDrop($event, index)"
                @dragend="handleDragEnd"
                @touchstart="handleTouchStart($event, index)"
                @touchmove="handleTouchMove($event, index)"
                @touchend="handleTouchEnd">
                <div class="drag_handle">
                  <i class="el-icon-rank"></i>
                </div>
                <div class="material_thumbnail" @click="handlePreviewMaterial(item)">
                  <img :src="item.thumbnail" alt="">
                  <div v-if="item.type === 'video'" class="video_overlay">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
                <div class="material_info">
                  <p class="material_name">{{ item.name }}</p>
                  <p class="material_type">{{ item.type === 'video' ? '视频 · ' + item.duration + 's' : '图片' }}</p>
                </div>
                <el-button type="text" class="delete_btn" @click="handleRemove(item.id)">
                  <i class="el-icon-delete" style="color: #f56c6c;"></i>
                </el-button>
              </div>
            </div>
          </div>

          <!-- 配乐设置 -->
          <div class="part">
            <h5>配乐设置</h5>
            <div class="music_card">
              <div class="music_header">
                <div class="music_info">
                  <i class="el-icon-headset music_icon"></i>
                  <div>
                    <p class="music_title">是否增加配乐</p>
                    <p class="music_desc">模型随机生成配乐</p>
                  </div>
                </div>
                <el-switch v-model="addMusic" active-color="#50b85c"></el-switch>
              </div>

              <!-- 配乐风格选择 -->
              <div v-if="addMusic" class="music_styles">
                <h6>配乐风格</h6>
                <el-radio-group v-model="musicStyle" class="music_style_group">
                  <div class="style_grid">
                    <div
                      :class="['style_option', { 'selected': musicStyle === 'relaxing' }]"
                      @click="musicStyle = 'relaxing'">
                      <el-radio label="relaxing">轻松舒缓</el-radio>
                    </div>
                    <div
                      :class="['style_option', { 'selected': musicStyle === 'energetic' }]"
                      @click="musicStyle = 'energetic'">
                      <el-radio label="energetic">活力动感</el-radio>
                    </div>
                    <div
                      :class="['style_option', { 'selected': musicStyle === 'elegant' }]"
                      @click="musicStyle = 'elegant'">
                      <el-radio label="elegant">优雅古典</el-radio>
                    </div>
                  </div>
                  <div
                    :class="['style_option', { 'selected': musicStyle === 'custom' }]"
                    @click="musicStyle = 'custom'">
                    <el-radio label="custom">自定义风格</el-radio>
                  </div>
                </el-radio-group>

                <!-- 自定义配乐描述 -->
                <div v-if="musicStyle === 'custom'" class="custom_music_input">
                  <h6>自定义配乐描述</h6>
                  <el-input
                    v-model="customMusicStyle"
                    placeholder="例如：科技感未来主义、轻快的爵士乐..."
                    clearable>
                  </el-input>
                </div>
              </div>
            </div>
          </div>

          <!-- 生成按钮 -->
          <div class="btn_save">
            <el-button
              type="success"
              :loading="isGenerating"
              @click="handleGenerate"
              :disabled="selectedItems.length === 0 || !customerValue"
              style="width:100%;">
              <i class="el-icon-film"></i>
              {{ isGenerating ? '生成中...' : '一键生成视频' }}
            </el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>

          <!-- 生成记录 -->
          <div class="part" v-if="generatedVideos.length > 0">
            <h5>生成记录</h5>
            <div class="video_result_grid">
              <div
                v-for="(video, index) in generatedVideos"
                :key="video.id"
                class="video_result_item">
                <div class="video_thumbnail" @click="handlePlayVideo(video)">
                  <img :src="video.thumbnail" alt="">
                  <div class="video_play_overlay">
                    <i class="el-icon-video-play"></i>
                  </div>
                  <span class="video_duration">{{ video.duration }}s</span>
                </div>
                <div class="video_info">
                  <p class="video_title">拼接视频 {{ index + 1 }} · {{ video.itemCount }} 个素材</p>
                  <div class="video_actions">
                    <el-button size="mini" type="success" plain @click="handleCollect(video)">收藏</el-button>
                    <el-button size="mini" type="success" plain @click="handleDownload(video)">下载</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 生成库弹窗 -->
        <el-dialog
          title="生成库"
          :visible.sync="libraryOpen"
          width="70%"
          :close-on-click-modal="false">
          <p class="dialog_hint">从过往生成的素材中选择</p>
          <div class="library_filter">
            <span class="filter_label">筛选类型</span>
            <el-select v-model="filterType" placeholder="请选择" style="width: 150px;">
              <el-option label="全部" value="all"></el-option>
              <el-option label="仅图片" value="image"></el-option>
              <el-option label="仅视频" value="video"></el-option>
            </el-select>
          </div>
          <div v-if="libraryLoading" class="library_loading">
            <i class="el-icon-loading"></i>
            <p>加载中...</p>
          </div>
          <div v-else-if="filteredLibrary.length === 0" class="library_empty">
            <i class="el-icon-picture-outline"></i>
            <p>暂无素材</p>
          </div>
          <div v-else class="library_grid">
            <div
              v-for="item in filteredLibrary"
              :key="item.id"
              :class="['library_item', { 'selected': isItemSelected(item.id) }]"
              @click="handleAddFromLibrary(item)">
              <div class="library_thumbnail">
                <img :src="item.thumbnail" alt="">
                <div v-if="item.type === 'video'" class="video_badge">
                  <i class="el-icon-video-play"></i> {{ item.duration }}s
                </div>
                <div v-if="isItemSelected(item.id)" class="selected_overlay">
                  <span class="selected_badge">已添加</span>
                </div>
              </div>
              <div class="library_item_info">
                <p class="name">{{ item.name }}</p>
                <p class="type">{{ item.type === 'video' ? '视频' : '图片' }}</p>
              </div>
            </div>
          </div>
          <div slot="footer" class="dialog_footer">
            <el-button type="success" @click="libraryOpen = false">完成</el-button>
          </div>
        </el-dialog>

        <!-- 上传弹窗 -->
        <el-dialog
          title="上传新素材"
          :visible.sync="uploadOpen"
          width="600px"
          :close-on-click-modal="false">
          <p class="dialog_hint">支持上传图片（JPG、PNG）或视频文件</p>
          <div class="upload_dialog_content">
            <el-upload
              class="upload_dragger"
              drag
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleUpload"
              accept="image/*,video/*">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </div>
        </el-dialog>

        <!-- 视频播放弹窗 -->
        <el-dialog
          title="视频播放"
          :visible.sync="videoPlayerOpen"
          width="auto"
          :close-on-click-modal="true"
          custom-class="video-preview-dialog"
          :modal-append-to-body="true"
          :append-to-body="true"
          @close="currentPlayingVideo = null">
          <div v-if="currentPlayingVideo" class="video_player_container">
            <video
              :src="currentPlayingVideo.url"
              controls
              autoplay
              class="video_player"
              controlsList="nodownload">
              您的浏览器不支持视频播放
            </video>
            <div class="video_player_info">
              <p class="player_video_title">拼接视频 · {{ currentPlayingVideo.itemCount }} 个素材</p>
              <p class="player_video_duration">时长: {{ currentPlayingVideo.duration }}s</p>
            </div>
          </div>
        </el-dialog>

        <!-- 素材预览弹窗 -->
        <el-dialog
          title="素材预览"
          :visible.sync="materialPreviewOpen"
          width="auto"
          :close-on-click-modal="true"
          custom-class="video-preview-dialog"
          :modal-append-to-body="true"
          :append-to-body="true"
          @close="currentPreviewMaterial = null">
          <div v-if="currentPreviewMaterial" class="material_preview_container">
            <!-- 视频预览 -->
            <video
              v-if="currentPreviewMaterial.type === 'video'"
              :src="currentPreviewMaterial.url"
              controls
              autoplay
              class="material_preview_video">
              您的浏览器不支持视频播放
            </video>
            <!-- 图片预览 -->
            <img
              v-else
              :src="currentPreviewMaterial.url || currentPreviewMaterial.thumbnail"
              class="material_preview_image"
              alt="">
            <div class="material_preview_info">
              <p class="preview_name">{{ currentPreviewMaterial.name }}</p>
              <p class="preview_type">{{ currentPreviewMaterial.type === 'video' ? '视频 · ' + currentPreviewMaterial.duration + 's' : '图片' }}</p>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SideBarComponent from '@/components/SideBarComponent'
import SubTitleComponent from '@/components/SubTitleComponent'
import { apiDownload } from '@/utils/download'

export default {
  name: 'VideoStitching',
  components: {
    HeaderComponent,
    SideBarComponent,
    SubTitleComponent
  },
  data() {
    return {
      title: '拼接长视频',
      customerData: [],
      customerValue: '',
      customerLoading: false,
      selectedItems: [],
      libraryOpen: false,
      uploadOpen: false,
      addMusic: false,
      musicStyle: 'relaxing',
      customMusicStyle: '',
      filterType: 'all',
      isGenerating: false,
      generatedVideos: [],
      dragIndex: null,
      touchStartY: 0,
      touchCurrentY: 0,
      isTouchDragging: false,
      libraryData: [],
      libraryLoading: false,
      videoPlayerOpen: false,
      currentPlayingVideo: null,
      pollTimer: null,
      materialPreviewOpen: false,
      currentPreviewMaterial: null
    }
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  },
  computed: {
    filteredLibrary() {
      if (this.filterType === 'all') {
        return this.libraryData
      }
      return this.libraryData.filter(item => item.type === this.filterType)
    }
  },
  created() {
    this.getCustomerList()
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.customerLoading = true
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        let _data = json.data.data
        if (json.data.errcode === 0) {
          this.customerData = _data.result
          if (this.global.type === 'client' && this.global.clientId) {
            this.customerValue = parseInt(this.global.clientId)
          } else if (this.customerData.length === 1) {
            this.customerValue = this.customerData[0].client_id
          } else if (this.global.type === 'manage' && this.global.clientName) {
            const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
            if (rememberedClient) {
              this.customerValue = rememberedClient.client_id
            }
          } else if (this.customerData.length > 0 && !this.customerValue) {
            this.customerValue = this.customerData[0].client_id
          }
        } else {
          this.$message.error(json.data.error || '获取客户列表失败')
        }
      }).catch(() => {
        this.$message.error('网络错误，无法获取客户列表')
      }).finally(() => {
        this.customerLoading = false
      })
    },
    // 客户选择变化
    customerChange(val) {
      const selectedCustomer = this.customerData.find(c => c.client_id === val)
      if (selectedCustomer) {
        this.global.clientId = selectedCustomer.client_id
        this.global.clientName = selectedCustomer.client_name
      }
    },
    // 打开生成库弹窗
    openLibrary() {
      this.libraryOpen = true
      this.getLibraryData()
    },
    // 获取生成库数据
    getLibraryData() {
      if (!this.customerValue) {
        this.$message.warning('请先选择客户')
        return
      }
      this.libraryLoading = true
      this.libraryData = []

      var url = "/api/?mod=effect&action=library_list"
      this.axios.post(url, {
        client_id: this.customerValue,
        page: 1,
        pagesize: 100,
        file_type: 'all'
      }).then((res) => {
        var libraryItems = []

        if (res.data.errcode === 0 && res.data.data.result) {
          res.data.data.result.forEach((item) => {
            var isVideo = item.file_type === 1
            libraryItems.push({
              id: (isVideo ? 'vid-' : 'img-') + item.effect_result_id,
              type: isVideo ? 'video' : 'image',
              url: item.file_url,
              thumbnail: item.photo_url,
              name: item.space_type || (isVideo ? '视频' : '效果图'),
              duration: item.duration || 5
            })
          })
        }

        this.libraryData = libraryItems
      }).catch(() => {
        this.$message.error('网络错误，无法获取生成库数据')
      }).finally(() => {
        this.libraryLoading = false
      })
    },
    // 判断素材是否已选中
    isItemSelected(id) {
      return this.selectedItems.some(item => item.id === id)
    },
    // 从库中添加素材
    handleAddFromLibrary(item) {
      if (!this.isItemSelected(item.id)) {
        this.selectedItems.push({ ...item })
      }
    },
    // 移除素材
    handleRemove(id) {
      this.selectedItems = this.selectedItems.filter(item => item.id !== id)
    },
    // 拖拽开始
    handleDragStart(e, index) {
      this.dragIndex = index
      e.target.classList.add('dragging')
    },
    // 拖拽经过
    handleDragOver(e, index) {
      if (this.dragIndex !== null && this.dragIndex !== index) {
        const items = [...this.selectedItems]
        const [removed] = items.splice(this.dragIndex, 1)
        items.splice(index, 0, removed)
        this.selectedItems = items
        this.dragIndex = index
      }
    },
    // 拖拽放下
    handleDrop(e, index) {
      e.preventDefault()
    },
    // 拖拽结束
    handleDragEnd(e) {
      this.dragIndex = null
      e.target.classList.remove('dragging')
    },
    // 触摸开始
    handleTouchStart(e, index) {
      // 只在拖拽手柄上触发
      const handle = e.target.closest('.drag_handle')
      if (!handle) return

      this.dragIndex = index
      this.touchStartY = e.touches[0].clientY
      this.isTouchDragging = true
    },
    // 触摸移动
    handleTouchMove(e, index) {
      if (!this.isTouchDragging || this.dragIndex === null) return

      e.preventDefault()
      this.touchCurrentY = e.touches[0].clientY

      // 获取所有素材项
      const list = this.$refs.materialList
      if (!list) return

      const items = list.querySelectorAll('.material_item')
      const touch = e.touches[0]

      // 找到触摸点下方的元素
      for (let i = 0; i < items.length; i++) {
        const rect = items[i].getBoundingClientRect()
        if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
          if (i !== this.dragIndex) {
            // 交换位置
            const itemsCopy = [...this.selectedItems]
            const [removed] = itemsCopy.splice(this.dragIndex, 1)
            itemsCopy.splice(i, 0, removed)
            this.selectedItems = itemsCopy
            this.dragIndex = i
          }
          break
        }
      }
    },
    // 触摸结束
    handleTouchEnd() {
      this.dragIndex = null
      this.isTouchDragging = false
      this.touchStartY = 0
      this.touchCurrentY = 0
    },
    // 上传新素材
    handleUpload(file) {
      const isVideo = file.raw.type.startsWith('video/')
      const isImage = file.raw.type.startsWith('image/')
      if (!isVideo && !isImage) {
        this.$message.error('只能上传图片或视频文件')
        return false
      }
      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB')
        return false
      }

      // OSS直传
      this.uploadToOSS(file.raw, isVideo)
    },
    // OSS直传
    uploadToOSS(file, isVideo) {
      var self = this
      var loading = this.$loading({
        lock: true,
        text: '正在上传素材...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 1. 获取OSS签名
      var _url = "/api/?mod=oss&action=signature"
      self.axios.post(_url).then(function(json) {
        if (json.data.errcode !== 0) {
          self.$message.error(json.data.error || '获取签名失败')
          loading.close()
          return
        }

        var ossData = json.data.data
        var timestamp = Date.now()
        var random = Math.floor(Math.random() * 10000)
        var fileExt = file.name.split('.').pop()
        var fileName = timestamp + '' + random + '.' + fileExt
        var key = ossData.dir + fileName

        // 2. 构造FormData上传到OSS
        var formData = new FormData()
        formData.append('key', key)
        formData.append('policy', ossData.policy)
        formData.append('OSSAccessKeyId', ossData.accessid)
        formData.append('signature', ossData.signature)
        formData.append('success_action_status', '200')
        formData.append('file', file)

        // 3. 直接上传到OSS
        self.axios.post(ossData.host, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [function(data, headers) {
            delete headers.Authorization
            return data
          }],
          // OSS返回空字符串，明确告诉axios这是成功的响应
          validateStatus: function(status) {
            return status === 200
          }
        }).then(function() {
          // 上传成功，添加到素材列表
          var ossUrl = ossData.host + '/' + key
          var newItem = {
            id: Date.now().toString(),
            type: isVideo ? 'video' : 'image',
            url: ossUrl,
            thumbnail: ossUrl,
            name: file.name,
            duration: isVideo ? 10 : undefined
          }
          self.selectedItems.push(newItem)
          self.uploadOpen = false
          self.$message.success('素材上传成功')
          loading.close()
        }).catch(function() {
          self.$message.error('素材上传失败')
          loading.close()
        })
      }).catch(function() {
        self.$message.error('网络错误')
        loading.close()
      })
    },
    // 生成视频
    handleGenerate() {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请至少添加一个素材')
        return
      }
      if (!this.customerValue) {
        this.$message.warning('请选择客户')
        return
      }

      this.isGenerating = true

      // 准备请求数据
      const materials = this.selectedItems.map(item => ({
        id: item.id,
        type: item.type,
        url: item.url,
        duration: item.duration
      }))

      const requestData = {
        client_id: this.customerValue,
        materials: JSON.stringify(materials),
        add_music: this.addMusic,
        music_style: this.addMusic ? (this.musicStyle === 'custom' ? this.customMusicStyle : this.musicStyle) : null
      }

      // 调用真实API提交生成任务
      const url = "/api/?mod=effect&action=save-longvideo"
      this.axios.post(url, requestData).then((res) => {
        if (res.data.errcode === 0) {
          this.$message.success('已提交生成任务，正在生成中...')
          // 开始轮询结果
          this.startPolling(res.data.data.effect_id, this.selectedItems.length)
        } else {
          this.$message.error(res.data.error || '视频生成失败')
          this.isGenerating = false
        }
      }).catch((error) => {
        console.error('视频生成错误:', error)
        this.$message.error('网络错误，视频生成失败')
        this.isGenerating = false
      })
    },
    // 开始轮询结果
    startPolling(effectId, itemCount) {
      let pollCount = 0
      const maxPolls = 120 // 最多轮询120次（4分钟，视频生成可能需要更长时间）

      const poll = () => {
        pollCount++
        console.log(`轮询第 ${pollCount} 次，effect_id: ${effectId}`)

        if (pollCount > maxPolls) {
          this.isGenerating = false
          this.$message.error('生成超时，请稍后查看历史记录')
          return
        }

        const url = "/api/?mod=video_stitching&action=result"
        const data = {
          effect_id: effectId
        }

        this.axios.post(url, data).then((res) => {
          if (res.data.errcode === 0) {
            const result = res.data.data

            if (result.status === 1) {
              // 生成成功
              const newVideo = {
                id: effectId,
                thumbnail: result.thumbnail || (this.selectedItems[0] && this.selectedItems[0].thumbnail),
                duration: result.duration || 0,
                itemCount: itemCount,
                url: result.video_url
              }
              this.generatedVideos.unshift(newVideo)
              this.isGenerating = false
              this.$message.success('视频生成成功！')
            } else if (result.status === 2) {
              // 生成失败
              this.isGenerating = false
              this.$message.error('视频生成失败，请重试')
            } else {
              // status === 0，继续轮询
              this.pollTimer = setTimeout(poll, 2000)
            }
          } else {
            this.isGenerating = false
            this.$message.error(res.data.error || '查询失败')
          }
        }).catch((error) => {
          console.error('轮询请求失败:', error)
          this.isGenerating = false
          this.$message.error('网络错误')
        })
      }

      // 立即执行第一次轮询
      poll()
    },
    // 播放视频
    handlePlayVideo(video) {
      this.currentPlayingVideo = video
      this.videoPlayerOpen = true
    },
    // 预览素材
    handlePreviewMaterial(item) {
      this.currentPreviewMaterial = item
      this.materialPreviewOpen = true
    },
    // 收藏
    handleCollect(video) {
      if (!video.id) {
        this.$message.error('视频信息不完整')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '收藏中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const url = "/api/?mod=effect&action=collect"
      this.axios.post(url, {
        video_id: video.id,
        client_id: this.customerValue
      }).then((res) => {
        if (res.data.errcode === 0) {
          this.$message.success('收藏成功')
        } else {
          this.$message.error(res.data.error || '收藏失败')
        }
      }).catch(() => {
        this.$message.error('网络错误，收藏失败')
      }).finally(() => {
        loading.close()
      })
    },
    // 下载
    handleDownload(video) {
      if (!video.url) {
        this.$message.error('视频地址不存在')
        return
      }

      let _href = ''
      let _videoUrl = video.url
      // 处理OSS URL，转换为代理路径
      if (_videoUrl.startsWith('https://oss.ylw.s136.ailo.vip')) {
        _href = _videoUrl.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos')
      } else if (_videoUrl.startsWith('https://aigc.oss.ylwai.cn')) {
        _href = _videoUrl.replace('https://aigc.oss.ylwai.cn', '/ai2_videos')
      } else {
        _href = _videoUrl
      }
      console.log('下载路径:', _href)
      apiDownload(_href)
    }
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  background: #f5f5f5;
  padding: 10px;
  .box {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    .tool {
      margin-bottom: 20px;
      h4 {
        margin-bottom: 10px;
        font-size: 16px;
        color: #333;
      }
      .search {
        /deep/ .el-select {
          width: 300px;
        }
      }
    }
    .part {
      margin-bottom: 20px;
      h5 {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
      }
      h6 {
        margin: 15px 0 10px 0;
        font-size: 13px;
        color: #666;
        font-weight: 500;
      }
      .page_header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        .header_icon {
          font-size: 24px;
          color: #50b85c;
        }
        h3 {
          font-size: 18px;
          color: #333;
          margin: 0;
        }
      }
      .editor_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        h5 {
          margin: 0;
        }
        .editor_actions {
          display: flex;
          gap: 10px;
        }
      }
      .empty_editor {
        padding: 60px 20px;
        text-align: center;
        border: 2px dashed #e4e7ed;
        border-radius: 8px;
        .empty_icon {
          font-size: 48px;
          color: #c0c4cc;
          margin-bottom: 15px;
        }
        p {
          color: #909399;
          margin-bottom: 10px;
        }
        .empty_hint {
          font-size: 12px;
          color: #c0c4cc;
          margin-bottom: 0;
        }
      }
      .material_list {
        max-height: 350px;
        overflow-y: auto;
        padding: 5px;
        -webkit-overflow-scrolling: touch;
        .material_item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          background: #fff;
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          margin-bottom: 10px;
          cursor: grab;
          transition: all 0.2s;
          user-select: none;
          -webkit-user-select: none;
          &:hover {
            border-color: #c0c4cc;
          }
          &.dragging {
            opacity: 0.6;
            border-color: #50b85c;
            border-style: dashed;
            background: #f0f9f0;
            transform: scale(1.02);
            box-shadow: 0 4px 12px rgba(80, 184, 92, 0.2);
          }
          .drag_handle {
            cursor: grab;
            color: #909399;
            font-size: 20px;
            padding: 10px;
            margin: -10px;
            margin-right: 2px;
            touch-action: none;
            &:active {
              cursor: grabbing;
              color: #50b85c;
            }
          }
          .material_thumbnail {
            position: relative;
            width: 64px;
            height: 64px;
            flex-shrink: 0;
            border-radius: 6px;
            overflow: hidden;
            background: #f5f7fa;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .video_overlay {
              position: absolute;
              inset: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(0, 0, 0, 0.3);
              i {
                font-size: 24px;
                color: #fff;
              }
            }
          }
          .material_info {
            flex: 1;
            min-width: 0;
            .material_name {
              font-size: 14px;
              font-weight: 500;
              color: #333;
              margin: 0 0 5px 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .material_type {
              font-size: 12px;
              color: #909399;
              margin: 0;
            }
          }
          .delete_btn {
            flex-shrink: 0;
            padding: 8px;
          }
        }
      }
      .music_card {
        padding: 16px;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        .music_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .music_info {
            display: flex;
            align-items: center;
            gap: 12px;
            .music_icon {
              font-size: 20px;
              color: #50b85c;
            }
            .music_title {
              font-size: 14px;
              font-weight: 500;
              color: #333;
              margin: 0;
            }
            .music_desc {
              font-size: 12px;
              color: #909399;
              margin: 5px 0 0 0;
            }
          }
        }
        .music_styles {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #e4e7ed;
          .music_style_group {
            width: 100%;
            display: block;
            .style_grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 10px;
              margin-bottom: 10px;
            }
            .style_option {
              padding: 12px;
              border: 2px solid #e4e7ed;
              border-radius: 8px;
              cursor: pointer;
              transition: all 0.3s;
              text-align: center;
              box-sizing: border-box;
              &:hover {
                border-color: #c0c4cc;
              }
              &.selected {
                border-color: #50b85c;
                background: #f0f9f0;
              }
              /deep/ .el-radio {
                margin-right: 0;
              }
            }
          }
          .custom_music_input {
            margin-top: 15px;
          }
        }
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .video_result_grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
      .video_result_item {
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        overflow: hidden;
        .video_thumbnail {
          position: relative;
          height: 180px;
          background: #f5f7fa;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .video_play_overlay {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.3);
            i {
              font-size: 32px;
              color: #fff;
            }
          }
          .video_duration {
            position: absolute;
            top: 8px;
            right: 8px;
            padding: 2px 8px;
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            font-size: 12px;
            border-radius: 4px;
          }
        }
        .video_info {
          padding: 12px;
          .video_title {
            font-size: 14px;
            color: #666;
            text-align: center;
            margin: 0 0 12px 0;
          }
          .video_actions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
        }
      }
    }
  }
  .dialog_hint {
    margin: 0 0 15px 0;
    padding: 10px;
    background: #f0f9ff;
    border-radius: 6px;
    font-size: 14px;
    color: #606266;
  }
  .library_filter {
    padding-left: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    .filter_label {
      font-size: 14px;
      color: #606266;
    }
  }
  .library_loading,
  .library_empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #909399;
    i {
      font-size: 48px;
      margin-bottom: 15px;
    }
    p {
      margin: 0;
      font-size: 14px;
    }
  }
  .library_grid {
    padding: 0 20px 20px 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    max-height: 400px;
    overflow-y: auto;
    .library_item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
      &.selected {
        opacity: 0.6;
        border-color: #50b85c;
      }
      .library_thumbnail {
        position: relative;
        height: 120px;
        background: #f5f7fa;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .video_badge {
          position: absolute;
          top: 8px;
          right: 8px;
          padding: 2px 8px;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          font-size: 12px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .selected_overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(80, 184, 92, 0.2);
          .selected_badge {
            padding: 4px 12px;
            background: #50b85c;
            color: #fff;
            font-size: 12px;
            border-radius: 20px;
          }
        }
      }
      .library_item_info {
        padding: 10px;
        .name {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin: 0 0 4px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .type {
          font-size: 12px;
          color: #909399;
          margin: 0;
        }
      }
    }
  }
  .upload_dialog_content {
    padding: 0 10px 20px 10px;
    .upload_dragger {
      width: 100%;
      /deep/ .el-upload {
        width: 100%;
      }
      /deep/ .el-upload-dragger {
        width: 100%;
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .dialog_footer {
    text-align: right;
  }
  .video_player_container {
    .video_player {
      width: 100%;
      max-height: 500px;
      background: #000;
      border-radius: 8px;
    }
    .video_player_info {
      margin-top: 15px;
      padding: 12px;
      background: #f5f7fa;
      border-radius: 6px;
      .player_video_title {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin: 0 0 8px 0;
      }
      .player_video_duration {
        font-size: 13px;
        color: #666;
        margin: 0;
      }
    }
  }
  .video_thumbnail {
    cursor: pointer;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.02);
    }
  }
  .material_preview_container {
    text-align: center;
    .material_preview_video {
      width: 100%;
      max-height: 450px;
      background: #000;
      border-radius: 8px;
    }
    .material_preview_image {
      max-width: 100%;
      max-height: 450px;
      object-fit: contain;
      border-radius: 8px;
    }
    .material_preview_info {
      margin-top: 15px;
      padding: 12px;
      background: #f5f7fa;
      border-radius: 6px;
      .preview_name {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin: 0 0 8px 0;
      }
      .preview_type {
        font-size: 13px;
        color: #666;
        margin: 0;
      }
    }
  }
  .material_thumbnail {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
/deep/ .el-dialog__header {
  background: #ffffff;
  padding: 20px !important;
  border-bottom: 1px solid #e4e7ed;
}
/deep/ .el-dialog__body {
  padding: 20px;
  background: #ffffff;
}
/deep/ .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #e4e7ed;
  background: #ffffff;
}
// 视频预览弹窗样式
/deep/ .video-preview-dialog {
  background: #fff;
  border-radius: 8px;
  margin: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  .el-dialog__header {
    background: #fff;
    padding: 15px 20px !important;
    border-bottom: 1px solid #e4e7ed;
  }
  .el-dialog__body {
    padding: 20px;
    background: #fff;
  }
  .video_player {
    max-width: 85vw;
    max-height: 70vh;
    display: block;
  }
  .material_preview_video {
    max-width: 85vw;
    max-height: 70vh;
    display: block;
  }
  .material_preview_image {
    max-width: 85vw;
    max-height: 70vh;
    object-fit: contain;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/VideoStitching/Index.vue